import Checkbox, { CheckboxProps } from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio, { RadioProps } from '@mui/material/Radio';
import Typography, { TypographyProps } from '@mui/material/Typography';
import { FlexBox, FlexBoxProps } from '../layout';

type ItemSelectorProps = FlexBoxProps & {
  label: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  handleChange?: (element: React.ChangeEvent<HTMLInputElement>) => void;
  type: 'checkbox' | 'radio' | 'check-button';
  checkboxProps?: CheckboxProps;
  radioProps?: RadioProps;
  labelProps?: TypographyProps;
  fullWidth?: boolean;
  startIcon?: React.ReactNode;
};

const ItemSelector: React.FC<ItemSelectorProps> = ({
  label,
  value,
  checked,
  disabled,
  handleChange,
  type,
  checkboxProps,
  radioProps,
  labelProps,
  fullWidth = false,
  startIcon,
  ...props
}) => (
  <FormControl component="fieldset">
    <FormControlLabel
      control={
        <FlexBox
          alignItems="center"
          justifyContent={fullWidth ? 'space-between' : 'flex-start'}
          px={2}
          py={type === 'check-button' ? 1 : 0.5}
          border={(theme) =>
            checked
              ? `1px solid ${theme.palette.blue?.[400]}`
              : `1px solid ${theme.palette.gray?.[300]}`
          }
          bgcolor={(theme) =>
            checked ? theme.palette.blue?.[50] : theme.palette.background.paper
          }
          boxSizing="border-box"
          borderRadius={2}
          width={fullWidth ? '100%' : 'fit-content'}
          gap={1}
          cursor={disabled ? 'default' : 'pointer'}
          {...props}
        >
          {startIcon && (
            <FlexBox
              alignItems="center"
              color={(theme) => theme.palette.blue?.[500]}
            >
              {startIcon}
            </FlexBox>
          )}
          <Typography
            noWrap
            variant="caption"
            {...labelProps}
            sx={{ userSelect: 'none', ...labelProps?.sx }}
          >
            {label}
          </Typography>
          {type === 'checkbox' || type === 'check-button' ? (
            <Checkbox
              disableRipple
              disableTouchRipple
              checked={checked}
              value={value}
              disabled={disabled}
              onChange={handleChange}
              sx={{ display: type === 'check-button' ? 'none' : 'inherit' }}
              {...checkboxProps}
            />
          ) : (
            <Radio
              disableRipple
              disableTouchRipple
              checked={checked}
              value={value}
              disabled={disabled}
              onChange={handleChange}
              size="small"
              {...radioProps}
            />
          )}
        </FlexBox>
      }
      label=""
      sx={{
        margin: 0,
        width: fullWidth ? '100%' : 'fit-content',
      }}
      disabled={disabled}
    />
  </FormControl>
);

export default ItemSelector;
